import React from 'react';
import { Cross2Icon, FileTextIcon } from '@radix-ui/react-icons';

interface InvoiceModalHeaderProps {
  invoiceId: string;
  onClose: () => void;
  disabled?: boolean;
}

export const InvoiceModalHeader: React.FC<InvoiceModalHeaderProps> = ({
  invoiceId,
  onClose,
  disabled = false,
}) => (
  <header className="invoice-details-modal__header">
    <div className="invoice-details-modal__header-copy">
      <span className="invoice-details-modal__icon" aria-hidden="true">
        <FileTextIcon />
      </span>
      <div>
        <h2 id="invoice-details-modal-title">Invoice Details</h2>
        <p>View and manage {invoiceId}</p>
      </div>
    </div>
    <button
      type="button"
      className="invoice-details-modal__close"
      onClick={onClose}
      disabled={disabled}
      aria-label="Close"
    >
      <Cross2Icon />
    </button>
  </header>
);
